/**
 * Leaf helpers for offer identity on map/list metadata.
 * Kept out of utils.ts so searchUtils can import without creating a cycle
 * through offerListKey → searchUtils.
 */

export function isOfferListMeta(offer: App.AnyOffer | App.OfferListMetaData): offer is App.OfferListMetaData {
  return 'offerId' in offer
}

export function getOfferId(offer: App.AnyOffer | App.OfferListMetaData): string {
  if (isOfferListMeta(offer)) {
    return offer.offerId
  }
  return offer.id
}
